import { Component, Input } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'irembogov-formcontrol-toggle-switch',
  templateUrl: './irembogov-formcontrol-toggle-switch.component.html',
  styleUrls: ['./irembogov-formcontrol-toggle-switch.component.scss'],
})
export class IrembogovFormcontrolToggleSwitchComponent
  implements ControlValueAccessor
{
  @Input() text?: string;
  @Input() uniqueId?: string;
  @Input() startMargin = 'ms-2';
  @Input() disabled = false;
  @Input() labelTextClass = 'my-2';
  @Input() formControl = new FormControl();

  private _onChange = () => {
    return;
  };
  private _onTouch = () => {
    return;
  };

  writeValue(obj: unknown): void {
    this.formControl.setValue(obj);
  }
  registerOnChange(fn: () => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this._onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  updateValue(event: boolean) {
    this.writeValue(event);
  }
}
